"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mandatory = {
    presence: { allowEmpty: false, message: "is required" }
};
exports.mandatory = mandatory;
var email = {
    presence: { allowEmpty: false, message: "is required" },
    email: true
};
exports.email = email;
var radioButton = {
    presence: { allowEmpty: false },
    inclusion: ["yes", "no"]
};
exports.radioButton = radioButton;
var money = {
    presence: { allowEmpty: false },
    numericality: {
        greaterThan: 0
    }
};
exports.money = money;
var numeric = {
    numericality: true
};
exports.numeric = numeric;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGlvbnMuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9saWIvZnVuY3Rpb25zL3ZhbGlkYXRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBTSxTQUFTLEdBQUc7SUFDZCxRQUFRLEVBQUUsRUFBQyxVQUFVLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRSxhQUFhLEVBQUM7Q0FDeEQsQ0FBQTtBQXVCTyw4QkFBUztBQXJCakIsSUFBTSxLQUFLLEdBQUc7SUFDVixRQUFRLEVBQUUsRUFBQyxVQUFVLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRSxhQUFhLEVBQUM7SUFDckQsS0FBSyxFQUFFLElBQUk7Q0FDZCxDQUFBO0FBa0JrQixzQkFBSztBQWhCeEIsSUFBTSxXQUFXLEdBQUc7SUFDaEIsUUFBUSxFQUFFLEVBQUMsVUFBVSxFQUFFLEtBQUssRUFBQztJQUM3QixTQUFTLEVBQUUsQ0FBQyxLQUFLLEVBQUUsSUFBSSxDQUFDO0NBQzNCLENBQUE7QUFheUIsa0NBQVc7QUFYckMsSUFBTSxLQUFLLEdBQUc7SUFDVixRQUFRLEVBQUUsRUFBQyxVQUFVLEVBQUUsS0FBSyxFQUFDO0lBQzdCLFlBQVksRUFBRTtRQUNWLFdBQVcsRUFBRSxDQUFDO0tBQ2pCO0NBQ0osQ0FBQTtBQU1zQyxzQkFBSztBQUo1QyxJQUFNLE9BQU8sR0FBRztJQUNaLFlBQVksRUFBRSxJQUFJO0NBQ3JCLENBQUE7QUFFNkMsMEJBQU8ifQ==